import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { getFileDownloadUrl } from "../../../../../api/firebase/firestoreService";
import { ToastMessages } from "../../../../../components/toasts/toastMessages";

export const downloadCsv = async (
  filePath: string,
  fileName?: string,
): Promise<void> => {
  try {
    // Get the download URL from Firebase Storage
    const downloadUrl = await getFileDownloadUrl(filePath);

    if (!downloadUrl) {
      console.error("Failed to get download URL");
      toast.error(ToastMessages.NAR_CSV_DOWNLOAD_FAILURE);
      return;
    }

    // Create a temporary anchor element to trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName ?? filePath.split("/").pop() ?? "download.csv";
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success(ToastMessages.NAR_CSV_DOWNLOAD_SUCCESS);
  } catch (error) {
    console.error("Error downloading CSV:", error);
    toast.error(ToastMessages.NAR_CSV_DOWNLOAD_FAILURE);
    throw error;
  }
};
